// #region Dependencias
import styled from 'styled-components'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
const StyledCardHeader = styled.div`
  background-color: ${({ color = 'primary' }) =>
    color === 'primary'
      ? colors.primary
      : color === 'secondary'
      ? colors.secondary
      : color === 'tertiary'
      ? colors.tertiary
      : 'transparent'};
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  border-bottom: 1px solid ${colors.light};
  color: ${({ color }) =>
    color === 'primary' || color === 'secondary' ? colors.light : colors.text};
  display: flex;
  flex-direction: ${({ flexDirection = 'row' }) => flexDirection};
  font-size: 1.25rem;
  font-weight: bold;
  justify-content: ${({ justifyContent = 'center' }) => justifyContent};
  padding: 1rem 2rem;
  text-align: ${({ align }) => align};
`
// #endregion

/**
 * Componente para renderizar el encabezado de una tarjeta.
 *
 * @class
 * @example
 * <Card>
 *  <CardHeader>...</CardHeader>
 *  ...
 * </Card>
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.align - Alineación del componente.
 * @param {string} [props.color="primary"] - Color de fondo del componente.
 * @param {string} [props.flexDirection="row"] - Atributo flex direction.
 * @param {string} [props.justifyContent="center"] - Atributo justify content.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const CardHeader = ({ children, ...props }) => {
  return <StyledCardHeader {...props}>{children}</StyledCardHeader>
}

export default CardHeader
